import { inject } from '@angular/core';
import { type CanActivateChildFn, Router } from '@angular/router';
import { injectOrg, injectUser } from '../user';

/**
 * Re-checks auth context on child navigations. This expects `userLoadedGuard`
 * to run on the parent shell route first.
 */
export const authContextHealthGuard: CanActivateChildFn = () => {
    const router = inject(Router);
    const user = injectUser();
    const org = injectOrg();

    const userErrorStatus = user.error()?.status;
    if (user.isError()) {
        return userErrorStatus === 404
            ? router.createUrlTree(['/onboarding'])
            : router.createUrlTree(['/login']);
    }

    if (org.isError()) {
        return router.createUrlTree(['/service-unavailable']);
    }

    if (!user()) {
        return router.createUrlTree(['/login']);
    }

    if (!org()) {
        return router.createUrlTree(['/service-unavailable']);
    }

    return true;
};
